module.exports = __webpack_public_path__ + "img/8.ed62ee71.svg";